export const ApiUrl = `${process.env.REACT_APP_SERVER_URL}/api`;
export const ServerUrl = process.env.REACT_APP_SERVER_URL || '';
export const ApiUrlOffline = '';

export const STORAGE_KEYS = {
	AccessToken: '@AccessToken',
};
